import React from 'react';
import CenturionLogoMark from './CenturionLogoMark';

/**
 * Brand - thin compatibility wrapper around <CenturionLogoMark/>.
 * Kept so existing call-sites (Header, Footer, Login, NotFound) continue
 * to work without churn. The white "license-plate" pill has been retired
 * - the transparent-bg wordmark + chevron now render directly on the
 * matte-black brand surface.
 */
export const Brand = (props) => <CenturionLogoMark {...props} />;

export default Brand;
